import { render, staticRenderFns } from "./ValidatorStats.vue?vue&type=template&id=34ec88ab&scoped=true&"
import script from "./ValidatorStats.vue?vue&type=script&lang=ts&"
export * from "./ValidatorStats.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorStats.vue?vue&type=style&index=0&id=34ec88ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec88ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
